import moment from "moment";
import React, { useState } from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import { useParams } from "react-router-dom";
import CustomPagination from "../../../../../components/Common/CustomPagination";
import TableActions from "../../../../../components/Common/TableActions";
import TableLayout from "../../../../../components/TableLayout";
import dataHandler from "../../../../../hooks/dataHandler";
import { GET_ORDER } from "../../../../../services/ApiCalls";
import { orderStatusArr } from "../../../../../utilities/const";
import {
  capitalizedFirstAlphaBet,
  findLabelOfStatus,
} from "../../../../../utilities/utilities";

const pendingTabStatusArr = ["requested", "pickUpScheduled"];

const ongoingTabStatusArr = [
  "orderPickedUp",
  "pending",
  "confirmed",
  "inroute",
  "OutForDelivery",
];

const UserOrder = ({ userId }) => {
  const [userDetails, setUserUserDetails] = useState();
  // const { id } = useParams();
  // const getData = catchAsync(async () => {
  //   const res = await VIEW_ORDER(id);
  //   checkResponse({ res, setData: setUserUserDetails });
  // });

  // useEffect(() => {
  //   if (id) getData();
  // }, [id]);

  const {
    setBody,
    body,
    data,
    loader,
    paginationHandler,
    searchHandler,
    total,
  } = dataHandler({
    api: GET_ORDER,
    extraBody: {
      orderStatus: pendingTabStatusArr,
      user: userId,
    },
  });
  const { id } = useParams();
  const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => {
        return <>{body.limit * (body.page - 1) + key + 1}</>;
      },
    },
    { head: "Order ID", accessor: "customOrderId" },

    {
      head: "Name",
      accessor: "name",
      component: (item, key) => {
        return (
          <>{item.customerDetails?.fname + " " + item.customerDetails?.lname}</>
        );
      },
    },
    {
      head: "Therapist",
      accessor: "name",
      component: (item, key) => {
        return (
          <>{item.vendorDetails?.fname + " " + item.vendorDetails?.lname}</>
        );
      },
    },
    {
      head: "Service",
      accessor: "serviceType",
      component: (item, key) => {
        return <>{item.serviceTypeDetails?.catName}</>;
      },
    },

    {
      head: "Amount",
      component: (item, key) => {
        return <>${item.orderTotal}</>;
      },
    },
  ];

  if (body?.orderStatus === "completed") {
    column.push({
      head: "Duration",
      accessor: "duration",
      component: (item, key, arr) => <>{item?.duration || 1} hour</>,
    });
  }

  column.push(
    {
      head: "Booking Date",
      accessor: "Scheduled",
      component: (item, key, arr) => (
        <>{moment(item.scheduled_utc).format("DD-MM-YYYY")}</>
      ),
    },
    // {
    //   head: "Slot",
    //   accessor: "slot",
    //   component: (item, key, arr) => (
    //     <>{moment(item.date_created_utc).format("HH:MM")}</>
    //   ),
    // },
    {
      head: "Payment Mode",
      accessor: "paymentMethod",
      component: (item, key, arr) => <>{item.paymentMethod}</>,
    },
    {
      head: "Payment Status",
      accessor: "paymentStatus",
      component: (item, key, arr) => <>{item.paymentStatus}</>,
    }
  );

  if (body?.orderStatus === "completed") {
    column.push({
      head: "Submitted Reviews",
      accessor: "reviewCount",
      component: (item, key, arr) => <>{item.reviewCount}</>,
    });
  }

  column.push(
    {
      head: "Status",
      accessor: "orderStatus",
      component: (item, key, arr) => (
        <p
          className={`status   ${
            pendingTabStatusArr?.includes(item.orderStatus)
              ? "yellowLabel"
              : ongoingTabStatusArr?.includes(item.orderStatus)
              ? "yellowLabel"
              : item.orderStatus == "completed"
              ? "greenLabel"
              : item.orderStatus == "cancelled"
              ? "redLabel"
              : ""
          } rounded-pill px-0  m-0 text-capitalize py-1 text-center`}
        >
          {findLabelOfStatus(item.orderStatus)}
        </p>
      ),
    },
    {
      head: "Action",
      accessor: "Action",
      component: (item, key, arr) => (
        <TableActions viewLink={`/order-management/detail/${item._id}`} />
      ),
    }
  );

  return (
    <>
      <Col lg="12">
        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
          View Appointment
        </h4>
      </Col>
      <Col lg="12" className="my-2">
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="pending"
          onSelect={(selectedKey) =>
            setBody((p) => ({
              ...p,
              orderStatus: selectedKey,
              ...(selectedKey === "pending" && {
                orderStatus: pendingTabStatusArr,
              }),
              ...(selectedKey === "ongoing" && {
                orderStatus: ongoingTabStatusArr,
              }),
              user: userId,
            }))
          }
        >
          <Nav
            variant="pills"
            className="inline-flex rounded-pill pillsTab"
            style={{ background: "#1C2E4F", maxWidth: "max-content" }}
          >
            {orderStatusArr.map((item) => (
              <Nav.Item key={item}>
                <Nav.Link
                  className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                  eventKey={item}
                >
                  {capitalizedFirstAlphaBet(
                    item == "pending" ? "upcoming" : item
                  )}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
          <div className="my-2 pt-3">
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </div>
        </Tab.Container>
      </Col>
    </>
  );
};

export default UserOrder;
